<template>
  <div>
    <div
      class="q-pa-md flex flex-center"
      style="height: 300px;"
          >
      <q-stepper
        v-model="step"
        ref="stepper"
        color="primary"
        animated
        style="width: 65vw"
      >
        <q-step
          :name="1"
          title="Getting Started"
          icon="preview"
          :done="step > 1"
        >
          <div v-if="filteredSessions?.length !== 0">
            <fieldset class="q-gutter-md q-mt-md">
              <legend class="text-left text-h5">
                Please select session to register for below:
              </legend>
              <q-banner v-if="sessionIdSelected !== ''" class="text-left q-mb-md" dense>
              <div class="text-h6">
                You have selected the session: <span class="text-weight-bold">
                  {{ sessionNameSelected }}</span>
              </div>
            </q-banner>
              <q-list bordered
                      separator>
                <q-item clickable
                        v-ripple
                        v-for="session in filteredSessions"
                        :key="session.sessionId"
                        @click="updateSelectedSession(session)"
                        :active="sessionIdSelected === session.sessionId"
                        active-class="menu-link">
                  <q-item-section class="text-h6"> {{ session.sessionName }} </q-item-section>
                </q-item>
              </q-list>
            </fieldset>
            <div v-show="sessionIdSelected && sessionDetails.description !== ''">
              <fieldset class="q-gutter-md q-mt-lg">
                <legend class="text-left text-h5">
                  Session Details
                </legend>
                <q-separator />
                <div class="text-left"
                    v-html="sessionDetails.description">
                </div>
              </fieldset>
            </div>
            <fieldset class="q-gutter-md q-mt-lg"
                      v-show="sessionIdSelected && !!sessionDetails.agreementUri
                        && sessionDetails.agreementUri !== ''
                        && !hasAppliedForSession">
              <legend class="text-left text-h5">
                Acknowledgement of Housing Agreement
              </legend>
              <q-separator />
              <div class="text-left text-body1 q-gutter-md">
                To proceed, please review our
                <a :href="sessionDetails.agreementUri" target="_blank" style="margin: 0px">
                Housing Agreement</a> for your application session. By acknowledging below,
                you agree to abide by all provisions as it applies to your housing
                application and record with DigiPen Housing.
              </div>
              <div class="q-gutter-md row items-start">
                <q-checkbox v-model="hasAgreedToTermsAndConditions"
                            label="Yes, I have reviewed the Housing Agreement for my
                            application session and agree to abide by the provisions listed."
                            :false-value="false"
                            style="margin-right: 40px; margin-top: 28px" />
              </div>
            </fieldset>
            <div>
              <b>NOTE:</b>
              <legend class="text-left text-body1 q-gutter-md">
                <div>
                  Please note that any updates to personal information,
                  address, and/or emergency contacts
                  will not be reflected on Colleague Self Service (CSS),
                  as this is a proprietary application
                  managed by DigiPen Housing LLC. If you would like
                  the information inputted in this application to reflect on your CSS
                  account (DigiPen main record system),
                  please make the
                  appropriate changes
                  <a href="https://selfservice.digipen.edu/Student/Account/Login?ReturnUrl=%2fstudent%2f"> Here</a>.
                </div>
                <div>
                  Please also note that necessary information such as your Name,
                  School Email,
                  and Vehicle Information,
                  may be shared with the property owners that DigiPen Housing and
                  Residence Life partners with for
                  property management purposes. Your Chosen Name and School Email
                  may also additionally be provided
                  to assigned roommates. For any questions or concerns on who is
                  provided this information,
                  please contact <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>.
                </div>
              </legend>
            </div>
          </div>
          <div v-else>
            <div class="text-h5">
              There are no available sessions for you to apply for at this time.
              - Please contact <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
              if you have any questions
            </div>
          </div>
        </q-step>
        <q-step
          :name="2"
          title="Personal Information"
          icon="account_circle"
          :done="step > 2"
        >
          <StudentInformation
            ref="studentInformationForm"
            @CheckIfFormIsValid="CheckFormIsValid($event)"
          />
        </q-step>

        <q-step
          :name="3"
          title="Housing Preferences"
          icon="assignment"
          :done="step > 3"
        >
          <ApplicationPreferences
            ref="applicationPreferenceForm"
            @CheckIfFormIsValid="CheckFormIsValid($event)"
          />
        </q-step>

        <q-step
          :name="4"
          title="Review Submission"
          icon="fact_check"
          :done="step > 4"
        >
          <ApplicationDetailedSummary :isApplying="true" :isReadOnly="true" />
        </q-step>

        <q-step
          :name="6"
          title="Done!"
          icon="done"
          active-icon="done"
          style="height: 75vh"
        >
          <h5>
            Congratulations!
            <br />
            <q-icon
              name="check_circle"
              size='42px'
              color='green'
            />
            You have successfully submitted your application!
          </h5>
          <div
            v-show="sessionDetails.depositAmount !== 0"
            class="q-mt-lg text-h6"
          >
            The next step is to pay the session deposit if you haven't done so yet.
            <br />
            You can access the deposit page from under the general information section in
            the housing home page
            <br />
            or by clicking
            <router-link
              :to="{
                name: 'DepositPayment',
                params: { applicationId: applicationDetails.applicationId
              }}"
              class="q-mt-md"
            >Here.</router-link>
          </div>
        </q-step>

        <template v-slot:navigation>
          <q-stepper-navigation>
            <q-btn
              v-if="step > 1 && step !== 6"
              flat
              color="primary"
              @click="$refs.stepper.previous()"
              label="Back"
              class="q-ml-sm"
              no-caps
            />
            <div v-if="step === 1 && filteredSessions.length === 0">
            </div>
            <q-btn
              v-else-if="!hasAppliedForSession"
              @click="StepForward(step)"
              color="primary"
              :label="step === 4 ? 'Submit'
              : step === 6 ? 'Finish'
              : 'Continue'"
              class="q-ma-sm"
              no-caps
              :disable="sessionIdSelected === '' || hasAgreedToTermsAndConditions === false
              ? '' : false"
            />
            <div v-else>
              You already Applied for this Session.
              <router-link to="/">Check application status here.</router-link>
            </div>
          </q-stepper-navigation>
        </template>
      </q-stepper>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useQuasar } from 'quasar';

import useSession from '@/hooks/session';
import useApplication from '@/hooks/application';
import useAuth from '@/hooks/auth';
import useUser from '@/hooks/user';
// import useUiUtilities from '@/utilities/uiUtilities';
import filterSessionsByOIPStatus from '@/utilities/sessionFilterUtility';
import useFilter from '@/utilities/filters';
import ApplicationDetailedSummary from './ApplicationDetailedSummary.vue';
import ApplicationPreferences from './ApplicationPreferences.vue';
import StudentInformation from './StudentInformation.vue';

export default {
  async setup() {
    const router = useRouter();
    const route = useRoute();
    const $q = useQuasar();

    const {
      sessionId,
      fetchSession,
      fetchSessionNameIds,
      getIsPlacedInPreviousSession,
      sessionDetails,
      resetSession,
      sessionIdSelected,
    } = useSession();
    const isFromLanding = computed(() => route.query.source === 'landing');
    if (isFromLanding.value === false) {
      sessionIdSelected.value = null;
    }

    const {
      applicationDetails,
      studentsApplications,
      getApplicationsByUserId,
      resetApplication,
      getPreFilledApplication,
      createApplication,
    } = useApplication();

    const { user } = useAuth();
    const userHook = useUser();
    // const { notifyResult } = useUiUtilities();
    const { sessionNameIdsFilteredByRole: originalFilteredSessions } = useFilter();
    const filteredSessions = ref([]);

    const isImportingSession = ref(false);
    const importSelected = ref('None');
    const isFormValid = ref(false);
    const stepper = ref(null);
    const sessionIds = ref([]);
    const hasAppliedForSession = ref(false);
    const hasAgreedToTermsAndConditions = ref(false);
    let hasResetApplication = false;

    const studentInformationForm = ref();
    const applicationPreferenceForm = ref();

    resetSession();

    const preSubmitAddDetails = () => {
      applicationDetails.value.sessionId = sessionIdSelected.value;
      applicationDetails.value.status = 'Submitted';
      applicationDetails.value.userId = user.value.userId;

      // the user is required to agree before beginning the form
      applicationDetails.value.agreementTermsAndConditions = true;
    };

    const StepForward = async (step) => {
      $q.loading.show();

      window.scrollTo(0, 0);
      let goToNextStep = true;

      if (step === 1) {
        hasResetApplication = false;
      }

      if (step === 2) {
        await studentInformationForm.value.onSubmit();
        goToNextStep = isFormValid.value;
      }

      if (step === 3) {
        await applicationPreferenceForm.value.onSubmit();
        goToNextStep = isFormValid.value;
      }
      if (step === 4) {
        preSubmitAddDetails();
        const creationResponse = await createApplication();
        // notifyResult(creationResponse.status, creationResponse);
        if (creationResponse.status !== 201) {
          goToNextStep = false;
        }
      }
      if (step === 6) {
        router.push('/');
      }

      if (goToNextStep) {
        stepper.value.next();
      }

      $q.loading.hide();
    };

    const CheckFormIsValid = async (formState) => {
      isFormValid.value = formState;
    };

    const updateHasAppliedForSession = () => {
      if (sessionIds.value.includes(sessionIdSelected.value)) {
        hasAppliedForSession.value = true;
      } else {
        hasAppliedForSession.value = false;
      }
    };

    const updateSelectedSession = async (startSession) => {
      $q.loading.show();
      hasAgreedToTermsAndConditions.value = false;
      if (!hasResetApplication) {
        resetApplication();
        await getPreFilledApplication();
        hasResetApplication = true;
      }
      if (startSession) {
        sessionIdSelected.value = startSession.sessionId;
        sessionId.value = startSession.sessionId;
        await fetchSession(sessionId.value, true);

        updateHasAppliedForSession();
      }
      $q.loading.hide();
    };

    const initializeSessions = async () => {
      try {
        $q.loading.show();
        await fetchSessionNameIds(true);
        await getApplicationsByUserId(user.value.userId);

        // Store existing applications
        studentsApplications.value.forEach((app) => {
          sessionIds.value.push(app.sessionId);
        });

        const sessionsWithDetails = await Promise.all(
          originalFilteredSessions.value.map(async (session) => {
            const details = await fetchSession(session.sessionId);
            return {
              label: session.sessionName,
              value: session.sessionId,
              sessionType: details.sessionType,
              details,
            };
          }),
        );

        // Apply OIP filtering with the complete data
        const filteredResults = await filterSessionsByOIPStatus(
          sessionsWithDetails,
          user.value.username,
          user.value.colleagueId,
          {
            getOipStudents: userHook.getOipStudents,
            fetchSession,
          },
        );

        if (filteredResults?.length > 0) {
          const convertedSessions = filteredResults.map((session) => ({
            sessionId: session.value,
            sessionName: session.label,
            sessionType: session.sessionType,
          }));

          // TODO: Update placement checks when intent to return is implemented
          const placementChecks = await Promise.all(
            convertedSessions.map((session) => getIsPlacedInPreviousSession(session.sessionId)),
          );

          filteredSessions.value = convertedSessions.filter(
            (session, index) => !placementChecks[index],
          );

          if (isFromLanding.value && sessionIdSelected.value && filteredSessions.value.length > 0) {
            const selectedSession = filteredSessions.value.find(
              (session) => session.sessionId === sessionIdSelected.value,
            );
            if (selectedSession) {
              await updateSelectedSession(selectedSession);
            }
          }
        } else {
          filteredSessions.value = [];
        }
        $q.loading.hide();
      } catch (error) {
        console.error('Error initializing sessions:', error);
        $q.loading.hide();
      }
    };
    await initializeSessions();

    const checkAgreementSelected = (val) => val || 'You must agree to the Housing Agreement.';
    const sessionNameSelected = computed(() => filteredSessions.value.find((session) => session.sessionId === sessionIdSelected.value)?.sessionName || '');
    return {
      agreementToggle: ref(),
      checkAgreementSelected,
      filteredSessions,
      hasAppliedForSession,
      stepper,
      step: ref(1),
      selectedSession: ref(''),
      CheckFormIsValid,
      StepForward,
      applicationDetails,
      isImportingSession,
      importSelected,
      updateSelectedSession,
      sessionIdSelected,
      sessionNameSelected,
      sessionDetails,
      studentInformationForm,
      applicationPreferenceForm,
      hasAgreedToTermsAndConditions,
    };
  },
  components: {
    StudentInformation,
    ApplicationPreferences,
    ApplicationDetailedSummary,
  },
};
</script>
